/**
 *
 */
import axios from 'axios'
import qs from 'qs'
import { Message } from 'element-ui'
import store from '../store/index.js'
// 内网
//const baseURL = 'http://172.24.140.163:8082/'
const baseURL = process.env.API_ROOT
const bomtBaseURL = process.env.BOMT_API_ROOT
// 本地不需要加 url,都默认http://localhost:8082 ,发版本时才需要关注
//吉利
//const baseURL="http://mall-dev.geely.com/mall-admin";
axios.interceptors.request.use(config => {
  // loading
  //config.data=JSON.stringify(config.data);
  // config.headers={
  //   'Content-Type':'application/x-www-form-urlencoded'
  // };
  config.headers = {
	guideActivity: sessionStorage.getItem('guideActivity') || '',
	guidePlatform: sessionStorage.getItem('guidePlatform') || '',
	regionCode: store.state.department,
	  ...config.headers
  }
  return config
}, error => {
  return Promise.reject(error)
});

axios.interceptors.response.use(response => {
  return response
}, error => {
	Message.error(error.toString())
  return Promise.resolve(error.response)
});

function checkStatus(response) {
  // 如果http状态码正常，则直接返回数据
  if (response && (response.status === 200 || response.status === 304 || response.status === 400)) {
    if(response.data.code == 'fail' && response.data.message == '18001') {
      // localStorage.removeItem('apiKey')
    }
    return response;
  }
  // 异常状态下，把错误信息返回去
  return false;
}

function checkCode(res) {
  return false;
}

export default {
  post(url, data) {
    return axios({
      method: 'post',
      baseURL: baseURL,
      url,
      data: qs.stringify(data),
      timeout: 60000,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'apiKey': localStorage.getItem('apiKey') || '',
        'txCookie': localStorage.getItem('txCookie') || ''
      }
    }).then(
      (response) => {
        return checkStatus(response)
      }
    ).catch(
      (res) => {
        return checkCode(res)
      }
    )
  },
  postJson(url, data) {
    return axios({
      method: 'post',
      baseURL: baseURL,
      url,
      data: data,
      timeout: 60000,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
        'apiKey': localStorage.getItem('apiKey') || '',
        'txCookie': localStorage.getItem('txCookie') || ''
      }
    }).then(
      (response) => {
        return checkStatus(response)
      }
    ).catch(
      (res) => {
        return checkCode(res)
      }
    )
  },
  postPic(url, data) {
    return axios({
      method: 'post',
      baseURL: baseURL,
      url,
      data: data,
      timeout: 60000,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'multipart/form-data; charset=UTF-8',
        'apiKey': localStorage.getItem('apiKey') || ''
      }
    }).then(
      (response) => {
        return checkStatus(response)
      }
    ).catch(
      (res) => {
        return checkCode(res)
      }
    )
  },
  get(url, params,config) {
    return axios({
      method: 'get',
      baseURL: baseURL,
      url,
      params: { ...params }, // get 请求时带的参数
      timeout: 60000,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json;charset=UTF-8',
		    'apiKey': localStorage.getItem('apiKey') || '',
		    ...config
      }
    }).then(
      (response) => {
        return checkStatus(response)
      }
    ).catch(
      (res) => {
        return checkCode(res)
      }
    )
  },
  getBaseUrl() {
    return baseURL;
  },
	bomtPost(url, data) { // 调用智能营销的接口
		return axios({
			method: 'post',
			baseURL: bomtBaseURL,
			url,
			data: qs.stringify(data),
			timeout: 60000,
			headers: {
				'X-Requested-With': 'XMLHttpRequest',
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
			}
		}).then(
			(response) => {
				let temp = checkStatus(response)
				if (temp && temp.data && temp.data.status === 200) {
					temp.data.code = 'success'
				}
				return temp
			}
		).catch(
			(res) => {
				return checkCode(res)
			}
		)
	}
}



// WEBPACK FOOTER //
// ./src/util/http.js